import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ReferencialAppList from '../../../../referencial/components/ReferencialAppList'
import { getLabel } from '../../../../utils/StoreUtils'
import { push } from '@lagunovsky/redux-react-router'
import { LIST_PANEL, MAP_PANEL, MAT_HEADERS } from '../../../constants/MaterielConstants'
import VariousMaterielAction from '../../variousMateriel/actions/VariousMaterielAction'
import { isUndefined, orderBy } from 'lodash'
import MaterielsMapComponent from '../../map/MaterielsMapComponent'
import { PATH_MATERIEL_VARIOUS_MATERIEL } from '../../../../home/constants/RouteConstants'
import { createIconMaterialAssignment, createIconMaterialState } from '../../../../utils/MaterielUtils'
import MaterielFilterForm from '../../filterPanel/MaterielFilterForm'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import DtoMaterielState from '../../../dto/DtoMaterielState'
import DtoHydrometricStation from '../../../../hydrometry/dto/DtoHydrometricStation'
import DtoVariousMaterielSituation from '../dto/DtoVariousMaterielSituation'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import VariousMaterielDto from '../dto/VariousMaterielDto'
import DtoVariousMaterielType from '../dto/DtoVariousMaterielType'
import DtoPiezometerLight from '../../../../piezometry/dto/DtoPiezometerLight'
import DtoQualitometerLight from '../../../../quality/dto/DtoQualitometerLight'
import DtoInstallation from '../../../../installation/dto/installation/DtoInstallation'
import PluviometerDto from '../../../../pluviometry/dto/PluviometerDto'
import { getDate } from '../../../../utils/DateUtil'
import queryString from 'query-string'
import HomeAction from 'home/actions/HomeAction'
import { componentHasHabilitations } from '../../../../utils/HabilitationUtil'
import { H_MAT_VARIOUS } from '../../../../account/constants/AccessRulesConstants'
import { searchAllCharacters } from '../../../../utils/StringUtil'
import { hasValue } from 'utils/NumberUtil'
import { Grid2 } from '@mui/material'

class VariousMaterielsApp extends Component {
    constructor(props) {
        super(props)
        const { idType } = queryString.parse(this.props.location.search)
        this.state = {
            view: LIST_PANEL,
            filter: {
                matType: isUndefined(idType) ? undefined : parseInt(idType),
            },
        }
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_MAT_VARIOUS)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.props.setHelpLink('materiel', '')
        if (!this.props.variousMateriels.length) {
            this.props.fetchVariousMateriels()
        }
        if (!this.props.variousMaterielTypes.length) {
            this.props.fetchVariousMaterielTypes()
        }
    }

    getExportData = (materiels) => {
        if (!materiels.length) {
            return []
        }
        const [head, ...tail] = materiels
        return [{ ...head, headers: MAT_HEADERS }, ...tail]
    }

    getHash = mat => searchAllCharacters(MAT_HEADERS.map(key => mat[key]).join(''))

    getFilterMateriels = materiels => {
        const {
            network,
            state,
            administrator,
            manufacturer,
            matType,
            displayEquipment,
            searchValue,
            displayOutOfService,
        } = this.state.filter
        const filterEquipment = !displayEquipment ? materiels.filter(({ isEquipment }) => !isEquipment) : materiels
        const filterAdministrator = administrator ? filterEquipment.filter(({ administratorId }) => administrator === administratorId) : filterEquipment
        const filterManufacturer = manufacturer ? filterAdministrator.filter(({ manufacturerId }) => manufacturer === manufacturerId) : filterAdministrator
        const filterStatusCode = hasValue(state) ? filterManufacturer.filter(({ statusCode }) => statusCode === state) : filterManufacturer
        const filterType = matType ? filterStatusCode.filter(({ materielType }) => materielType === matType) : filterStatusCode
        const filterNetwork = network ? filterType.filter(({ networkCode }) => network === networkCode) : filterType
        const filterOutOfService = displayOutOfService ? filterNetwork : filterNetwork.filter(({ statusCode }) => statusCode !== 0 && statusCode !== 5 && statusCode !== 6)
        const searchValueFormated = searchAllCharacters(searchValue)
        return searchValue ? filterOutOfService.filter(mat => this.getHash(mat).includes(searchValueFormated)) : filterOutOfService
    }

    getPanel = variousMateriels => {
        if (this.state.view === MAP_PANEL) {
            return (
                <MaterielsMapComponent
                    materiels={ variousMateriels }
                    materielLink={ PATH_MATERIEL_VARIOUS_MATERIEL }
                />
            )
        }
        const formattedVariousMateriels = variousMateriels.map(mat => ({
            ...mat,
            state: createIconMaterialState(mat.state, mat.statusCode),
            assignment: mat.statusCode === 1 && createIconMaterialAssignment(mat.assignment, mat.siteType) || '',
            nullValue: mat.isEquipment && <i className='material-icons' style={{ fontSize: '1.5rem' }}>devices_other</i>,
        }))
        return (
            <ReferencialAppList
                title={ i18n.variousMateriels }
                data={formattedVariousMateriels}
                exportData={this.getExportData(variousMateriels)}
                type={{ headers: ['nullValue', ...MAT_HEADERS] }}
                newAction={ () => this.props.push('/materiel/variousMateriel/new') }
                showPurgeButton={false}
                showNewButton={true}
                setTitleAction={HomeAction.setTitle([{
                    title: i18n.materiel,
                    href: 'materiel',
                }, {
                    title: i18n.variousMateriels,
                    href: 'materiel/variousMateriel',
                }]) }
                onClick={({ materielId }) => this.props.push(`/materiel/variousMateriel/${materielId}`)}
                searchable={false}
            />
        )
    }

    onChangeView = view => {
        this.setState({ view })
    }

    onValidate = filter => {
        this.setState({ filter })
    }

    getVariousType = () => this.props.variousMaterielTypes.filter(({ id, label }) => !!this.props.variousMateriels.find(({ materielType }) => materielType === id) && label).map(t => ({
        id: t.id,
        label: t.label,
    }))

    getCorrespondingSite = ({ siteType, siteCode }) => {
        switch (siteType) {
            case 1:
                return this.props.piezometers.find(({ id }) => id === siteCode)
            case 2:
                return this.props.pluviometers.find(({ id }) => id === siteCode)
            case 3:
                return this.props.qualitometers.find(({ id }) => id === siteCode)
            case 4:
                return this.props.hydrometricStations.find(({ id }) => id === siteCode)
            case 7:
                return this.props.installations.find(({ id }) => id === siteCode)
            default:
                return {}
        }
    }

    render() {
        const { variousMateriels, variousMaterielsLastSituations, materielStates, citiesIndex, variousMaterielTypes, contributors } = this.props
        const materiels = variousMateriels.map(mat => {
            const lastSituation = variousMaterielsLastSituations.find(s => s.idVarious === mat.id)
            const labelState = lastSituation ? getLabel(materielStates, lastSituation.statusCode) : ''
            const site = lastSituation && lastSituation.statusCode === 1 && lastSituation.siteType && lastSituation.siteCode && this.getCorrespondingSite(lastSituation) || {}
            const labelAssignment = (lastSituation && lastSituation.statusCode === 1 && lastSituation.siteName) || site.code || ''
            const city = site.townCode && citiesIndex[site.townCode] || undefined
            const cityLabel = city ? `${city.name} - [${city.code}]` : (site.townCode || '')
            const departmentLabel = city && city.departmentNumber ? city.departmentNumber : ''
            return {
                materielId: mat.id,
                name: mat.name,
                type: getLabel(variousMaterielTypes, mat.materielType),
                manufacturer: getLabel(contributors, mat.manufacturerId, 'labelDisplay', 'id'),
                state: labelState,
                statusCode: lastSituation && lastSituation.statusCode,
                stateDate: lastSituation && getDate(lastSituation.situationDate),
                city: cityLabel,
                administratorId: mat.administrator,
                serialNumber: mat.serialNumber,
                immoNum: mat.reference,
                assignment: labelAssignment,
                siteType: lastSituation && lastSituation.siteType,
                departmentShort: departmentLabel,
                purchaseDate: getDate(mat.purchaseDate),
                manufacturerId: mat.manufacturerId,
                networkCode: mat.networkCode,
                materielType: mat.materielType,
                isEquipment: mat.isEquipment,
                siteCode: lastSituation && lastSituation.siteCode,
                administrator: getLabel(contributors, mat.administrator, 'labelDisplay', 'code'),
            }
        })
        const filteredMateriels = this.getFilterMateriels(materiels)
        return (
            <Grid2 container spacing={1}>
                <Grid2 size={12}>
                    <MaterielFilterForm
                        view={this.state.view}
                        filter={this.state.filter}
                        changeView={this.onChangeView}
                        materiels={materiels}
                        typeList={orderBy(this.getVariousType(), 'label')}
                        onValidate={this.onValidate}
                        materielType='MATERIEL_TYPE'
                    />
                </Grid2>
                <Grid2 size={12}>
                    {this.getPanel(filteredMateriels) }
                </Grid2>
            </Grid2>
        )
    }
}

VariousMaterielsApp.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.object,
    }),
    getLink: PropTypes.func,
    variousMateriels: PropTypes.arrayOf(PropTypes.instanceOf(VariousMaterielDto)),
    variousMaterielsLastSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMaterielSituation)),
    variousMaterielTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMaterielType)),
    citiesIndex: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    materielStates: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielState)),
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    installations: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    push: PropTypes.func,
    fetchVariousMateriels: PropTypes.func,
    fetchVariousMaterielTypes: PropTypes.func,
    fetchMaterielStates: PropTypes.func,
    fetchContributors: PropTypes.func,
    fetchCities: PropTypes.func,
    setHelpLink: PropTypes.func,
}

const mapStateToProps = store => ({
    variousMateriels: store.VariousMaterielReducer.variousMateriels,
    variousMaterielsLastSituations: store.VariousMaterielReducer.variousMaterielsLastSituations,
    variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
    piezometers: store.PiezometryReducer.piezometersLight,
    pluviometers: store.PluviometryReducer.pluviometers,
    qualitometers: store.QualityReducer.qualitometersLight,
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    installations: store.InstallationReducer.installations,
    materielStates: store.MaterielReducer.materielStates,
    citiesIndex: store.CityReducer.citiesIndex,
    contributors: store.ContributorReducer.contributors,
})

const mapDispatchToProps = {
    push,
    fetchVariousMateriels: VariousMaterielAction.fetchVariousMateriels,
    fetchVariousMaterielTypes: VariousMaterielAction.fetchVariousMaterielTypes,
    setHelpLink: HomeAction.setHelpLink,
}

export default connect(mapStateToProps, mapDispatchToProps)(VariousMaterielsApp)
